// extracted by mini-css-extract-plugin
module.exports = {"downloadButton":"DownloadButton_downloadButton__Np2dv"};